import { React, useState,useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { GlobalContext } from "../Context/GlobalState";
import axios from "axios";

function Register() {
  const { API_URL } = useContext(GlobalContext);
 

  const navigate = useNavigate();
  const [values, setValues] = useState({
    email: "",
    password: "",
  });

  const handleRegister = (e) => {
    e.preventDefault();
    axios
      .post(API_URL + "/register", values)
      .then((res) => {
        if (res.data.code === "ER_DUP_ENTRY") {
          alert("Kullanıcı Adı Kullanımda !");
        } else {
          alert("Kayıt Başarılı :)");
          navigate("/");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleInput = (e) => {
    setValues((prev) => ({ ...prev, [e.target.name]: [e.target.value] }));
  };

  return (
    <div className="d-flex vh-100 bg-primary justify-content-center align-items-center">
      <div className="bg-white p-3 w-25">
        <h2>Kayıt Ol</h2>
        <form onSubmit={handleRegister}>
          <div className="my-2">
            <label htmlFor="username">Email</label>
            <input
              type="email"
              name="email"
              required
              placeholder="Email"
              className="form-control"
              onChange={handleInput}
            />
          </div>
          <div className="my-2">
            <label htmlFor="password">Şifre</label>
            <input
              type="password"
              name="password"
              placeholder="Şifre"
              minLength={6}
              required
              className="form-control"
              onChange={handleInput}
            />
          </div>
          <button
            className="btn btn-success w-100 my-2"
            type="submit"
            onClick={handleRegister}
          >
            Kayıt Ol
          </button>
          <Link to={"/"} className="btn btn-secondary w-100" type="submit">
            Giriş Yap
          </Link>
        </form>
      </div>
    </div>
  );
}

export default Register;
